import '../assets/css/connectWallet.css';
import ATOWhiteLogo from '../assets/Ato_White_Logo.png';

import React from 'react';
//import { NetworkErrorMessage } from '../components/NetworkErrorMessage';
import { networkList } from '../config/networks';

export function ConnectWallet({ connectWallet, autoConnectWallet, addChainToWallet, networkName, networkId, networkError, dismiss }) {
  const networkData = networkList.networks[0][parseInt(networkId,10)];
  //console.log('networkData.chainId:', networkData.chainId);

  // Open MetaMask in new tab
  const handleMetaMaskClick = () => {
    window.open('https://metamask.io/', '_blank');
  };

  return (
    <div className="container">

      <div className="row mt-5">
      <div className="col row">
        <img src={ATOWhiteLogo} alt="Ato_White_Logo.png" className="img_logo"></img>
      </div>

      <div className="col row justify-content- mt-4 pt-5 gallery ">
        <p></p>
        <p>Welcome to Āto!</p>
        <p>Āto is an NFT minting service that allows you to personalize an IP license that will be added to the metadata of your NFT.</p>
        <p>Please get your media file ready. </p>
        <p>We're on <strong>{networkData.networkName}</strong> so you'll need a handful of <strong>{/*<a href="https://www.coingecko.com/en/coins/polygon#markets">*/}{networkData.symbol}{/*</a>*/}</strong> to create your NFT.</p>
        <p></p>
      </div>
      </div>
      { !window.ethereum ? (
        <div className="row justify-content-center">
        <div className="col-6 p-4 text-center">
          <p className="connect">
            We can’t find an active MetaMask wallet on your browser. Please download it from their official website:
          </p>
          <button className="btn btn-warning" type="button" onClick={() => handleMetaMaskClick()}>
            Download MetaMask
          </button>
          <p className="mt-3">After MetaMask is installed, please refresh this page.</p>
        </div>
        </div>
      ) : (
      <div className="row justify-content-center">
        {/*<div className="col-12 text-center">{networkError && <NetworkErrorMessage message={networkError} dismiss={dismiss} />}</div>*/}
        <div className="p-4 text-center">
          <p className="connect">Please, set your MetaMask to <strong>{networkData.networkName}</strong> and refresh this page or clic on connect button.</p>
          <button className="btn btn-warning" type="button" onClick={autoConnectWallet}>
            Connect wallet To {networkData.networkName}
          </button>
        </div>
        <div className="p-4 text-center">
        <p className="connect">If <strong>{networkData.networkName}</strong> is not set on your MetaMask clic for auto-add or add it manually.</p>
          <button className="btn btn-warning" type="button" onClick={addChainToWallet}>
            Add {networkData.networkName} to MetaMask
          </button>
        </div>
        <div className="row justify-content">
        <p className="connect">Here's how to add manually <strong>{networkData.networkName}</strong> as a custom network:</p>
        <ul>
          <li>Network Name: <strong>{networkData.networkName}</strong></li>
          <li>New RPC URL: <strong>{networkData.RPC_URL}</strong></li>
          <li>ChainID: <strong>{networkData.chainId}</strong></li>
          <li>Symbol: <strong>{networkData.symbol}</strong></li>
          <li>Block Explorer URL: <strong>{networkData.scanlink}</strong></li>
        </ul>
        </div>
      </div>
      )}
    </div>
  );
};

//export default ConnectWallet;
